// extracted by mini-css-extract-plugin
module.exports = {"root":"CalendarPagination_root__2bLYH","action":"CalendarPagination_action__vziaI"};